import { FC } from 'react';
import { InlineNotification } from '@carbon/react';
import { formatTcWorkspaceDate } from 'utils/dates';
import type { AfeSourceDocument } from './types';

interface SourceDocumentBannerProps {
  sourceDocument: AfeSourceDocument | null;
}

const SourceDocumentBanner: FC<SourceDocumentBannerProps> = ({
  sourceDocument,
}) => {
  if (!sourceDocument) return null;

  const docLabel =
    sourceDocument.documentTitle ?? `Document #${sourceDocument.id}`;
  const populatedAt = formatTcWorkspaceDate(sourceDocument.autoConnectedAt);

  return (
    <InlineNotification
      kind="info"
      lowContrast
      hideCloseButton
      title="Auto-Connected"
      subtitle={`Auto-populated from ${docLabel} on ${populatedAt}.`}
    />
  );
};

export { SourceDocumentBanner };
